import React, {useEffect} from 'react';
import LogoutController from '../controller/logout.controller';

export default function Logout() {
  const controller = new LogoutController();

  useEffect(() => {
    controller.init();
  }, []);

  return <></>;
}
